import React from 'react';
import moment from 'moment';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { Icon, ICONS } from '../../Icons';

export default function SyllabusUploadStepCourseCreated({
  deliveryPreferences,
  course,
  rows,
  onDone,
}) {
  const deliveryDay = deliveryPreferences?.deliveryDay || 'Sunday';
  const readingOptions = deliveryPreferences?.readingOptions || [];
  const hasNewsSuggestions = readingOptions.includes(
    'readings_in_wild_course_topics',
  );
  const topicCount = rows?.length || 0;
  const courseName = course?.name || deliveryPreferences?.courseName || '';
  const startDate = course?.startDate
    ? moment(course.startDate).format('MMM D, YYYY')
    : '';
  const endDate = course?.endDate
    ? moment(course.endDate).format('MMM D, YYYY')
    : '';

  const canDoItems = [];
  if (!topicCount) {
    canDoItems.push('Create course topics');
  }
  if (!hasNewsSuggestions) {
    canDoItems.push('Turn on news suggestions tied to your topics');
  }
  canDoItems.push('Invite students to your course');

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            {"You've created the course "}
            {courseName}
            {topicCount > 0
              ? ` and ${topicCount} topic${topicCount !== 1 ? 's' : ''}`
              : ''}
            {'.'}
          </div>
        </div>
        <div className="section-con">
          {(startDate || endDate) && (
            <div className="syllabus-course-dates">
              {startDate && <span>Start date: {startDate}</span>}
              {endDate && <span>End date: {endDate}</span>}
            </div>
          )}
          {hasNewsSuggestions && (
            <p className="syllabus-news-notice">
              You turned on News Suggestions, and will receive articles every{' '}
              {deliveryDay}.
            </p>
          )}
          <div className="syllabus-can-do-label">You can now</div>
          <ul className="syllabus-step3-bullets">
            {canDoItems.map((text, i) => (
              <li key={i} className="syllabus-step3-bullet">
                <Icon icon={ICONS.CHECK} className="syllabus-step3-check" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="syllabus-step-footer">
          <div />
          <RectangularButton darkButton onClick={onDone}>
            Done
          </RectangularButton>
        </div>
      </div>
    </div>
  );
}
